import React, { Component, Suspense, lazy } from 'react';
/* import ReactDOM from 'react-dom'; */
import { hydrate, render } from "react-dom";
import { Router, Route, Switch, Redirect } from 'react-router';
import { createBrowserHistory } from 'history';
import './index.css';
import App from './App';
import Intro from './Intro';
import Closed from './Closed';
import * as serviceWorker from './serviceWorker';
import { I18nextProvider } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18next from 'i18next';
import common_en from './translations/en/common.json';
import common_vi from './translations/vi/common.json';

import * as dayjs from 'dayjs';

const supportedLanguages = ["en", "vi"]

i18next.use(LanguageDetector).init({
	interpolation: { escapeValue: false }, // React already does escaping
	lng: 'en', // language to use
	resources: {
		en: {
			common: common_en // 'common' is our custom namespace
		},
		vi: {
			common: common_vi
		}
	}
});

const history = createBrowserHistory();

function NotFound() {
  return (
    <div>
      <h2>Not Found</h2>
    </div>
  );
}

const rootElement = document.getElementById("root");

const now = dayjs();
const closedTime = dayjs("2021-12-31 23:59:59 +0700");

const AppContent = <Router history={history}>
<Suspense fallback={<div>Loading...</div>}>
  <I18nextProvider i18n={i18next}>
  <Switch>
    {(dayjs().isAfter(closedTime)) && (
    <>
    <Route path="/:lang/buy" component={Closed} />
    <Route
      path="/:lang/"
      render={props =>
        supportedLanguages.includes(props.match.params.lang) ? (
          <Closed {...props} />
        ) : (
          <Redirect to={`/en`} />
        )
      }
    />
    <Route component={Closed} />
    </>)}
    {(dayjs().isBefore(closedTime)) && (
    <>
    <Route path="/:lang/buy" component={App} />
    <Route
      path="/:lang/"
      render={props =>
        supportedLanguages.includes(props.match.params.lang) ? (
          <App {...props} />
        ) : (
          <Redirect to={`/en`} />
        )
      }
    />
    <Route component={App} />
    </>)}
  </Switch>
  </I18nextProvider>
</Suspense>
</Router>
if (rootElement.hasChildNodes()) {
  hydrate(AppContent, rootElement);
} else {
  render(AppContent, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
